/** Case-insensitive substring match on a trimmed query — the panel search's one rule. */
export function matchesFilterQuery(text: string, query: string): boolean {
  return text.toLocaleLowerCase().includes(query.trim().toLocaleLowerCase());
}
